/* Second-fragrance offer: fills [data-pc-sb] blocks (snippets/pc-second-bottle-offer.liquid)
 * with 2 suggestions. Source order (Firas 2026-09-30): wishlist, recently viewed,
 * related products, bestsellers; a Search & Discovery complementary pick for the
 * anchor product goes first when one is set (2026-10-14). Skips products in the cart, the Buy Now product,
 * unavailable products and the `hidden` tag. Never blocks the cart or checkout:
 * every failure leaves the block with its text and "Browse all fragrances" link. */
(function () {
  'use strict';
  var RECENT_KEY = 'pc_recent_viewed';
  var MAX = 2;

  function readJSON(store, key) {
    try { return JSON.parse(store.getItem(key)) || null; } catch (e) { return null; }
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Dhs. ' + v;
  }
  function rePeat() {
    [0, 300, 800].forEach(function (t) {
      setTimeout(function () {
        if (window.baCurr && typeof window.baCurr.rePeat === 'function') { try { window.baCurr.rePeat(); } catch (e) {} }
      }, t);
    });
  }

  // Recently viewed: written on product pages (buy-now-confirm renders there).
  function recordView() {
    var el = document.querySelector('[data-pc-sb-view]');
    if (!el) return;
    var h = el.getAttribute('data-pc-sb-view');
    try {
      var list = (readJSON(localStorage, RECENT_KEY) || []).filter(function (x) { return x !== h; });
      list.unshift(h);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 10)));
    } catch (e) {}
  }

  var cache = {};
  function productByHandle(h) {
    if (!cache[h]) {
      cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[h];
  }
  function listJSON(url, pick) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return (j && pick(j)) || []; })
        .catch(function () { return []; });
    }
    return cache[url];
  }

  function usable(p, exclude) {
    if (!p || !p.id || exclude[p.id]) return false;
    var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',');
    if (tags.some(function (t) { return String(t).trim().toLowerCase() === 'hidden'; })) return false;
    var v = (p.variants || []).find(function (x) { return x.available; });
    if (!v) return false;
    p._variant = v;
    return true;
  }

  function candidates(block) {
    var anchor = block.getAttribute('data-anchor');
    var wish = (readJSON(localStorage, 'pc_wishlist') || []).map(function (x) { return x && x.handle; });
    var recent = readJSON(localStorage, RECENT_KEY) || [];
    var handles = wish.concat(recent).filter(function (h, i, a) { return h && a.indexOf(h) === i; }).slice(0, 12);
    var sources = handles.map(function (h) { return function () { return productByHandle(h).then(function (p) { return p ? [p] : []; }); }; });
    if (anchor) {
      // Proven pairing first (growth audit 2026-10-13: Scarlet Sands + Halfeti
      // Amber in 3 of 7 multi-bottle orders). Set per product in Search &
      // Discovery > Complementary products; at most 1 here so slot 2 keeps
      // the shopper's own wishlist / recently viewed.
      sources.unshift(function () {
        return listJSON('/recommendations/products.json?product_id=' + encodeURIComponent(anchor) + '&limit=1&intent=complementary',
          function (j) { return (j.products || []).slice(0, 1); });
      });
      sources.push(function () {
        return listJSON('/recommendations/products.json?product_id=' + encodeURIComponent(anchor) + '&limit=10&intent=related',
          function (j) { return j.products; });
      });
    }
    sources.push(function () {
      return listJSON('/collections/theme-bestseller/products.json?limit=20', function (j) { return j.products; });
    });
    return sources;
  }

  function pick(block) {
    var exclude = {};
    (block.getAttribute('data-exclude') || '').split(',').forEach(function (id) { if (id) exclude[id] = true; });
    var chosen = [];
    var sources = candidates(block);
    function next(i) {
      if (chosen.length >= MAX || i >= sources.length) return Promise.resolve(chosen);
      return sources[i]().then(function (list) {
        (list || []).forEach(function (p) {
          if (chosen.length < MAX && usable(p, exclude)) { exclude[p.id] = true; chosen.push(p); }
        });
        return next(i + 1);
      });
    }
    return next(0);
  }

  function image(p) {
    var src = p.featured_image || (p.images && p.images[0]) || (p.image && p.image.src) || '';
    if (typeof src === 'object' && src) src = src.src || src.url || '';
    if (!src) return '';
    src = String(src);
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function render(block, products) {
    var list = block.querySelector('[data-pc-sb-list]');
    if (!list || !products.length) return;
    list.innerHTML = products.map(function (p) {
      var v = p._variant;
      var price = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
      var img = image(p);
      return '<li class="pc-sb__item">' +
        '<a class="pc-sb__img" href="/products/' + esc(p.handle) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="64" height="64" loading="lazy">' : '') +
        '</a>' +
        '<div class="pc-sb__meta"><a class="pc-sb__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
          '<span class="pc-sb__price"><span class="money">' + money(price) + '</span></span></div>' +
        '<button type="button" class="pc-sb__add" data-pc-sb-add="' + esc(v.id) + '">Add &amp; save ' + esc(block.getAttribute('data-pct') || '') + '</button>' +
      '</li>';
    }).join('');
    rePeat();
  }

  function renderInDrawer(drawer, revision, state) {
    if (!drawer || !drawer.renderContents) { window.location.href = '/cart'; return; }
    if (!drawer.isConnected || drawer !== document.querySelector('cart-drawer') || (drawer.renderRevision || 0) !== revision) return;
    return drawer.renderContents(state);
  }

  function addToDrawer(drawer, revision, variantId) {
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      return r.json();
    }).then(function (state) {
      return renderInDrawer(drawer, revision, state);
    });
  }

  function addInBuyNow(btn, variantId, block) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      var offer = block.querySelector('[data-pc-sb-offer]');
      var note = block.querySelector('[data-pc-sb-note]');
      if (offer) offer.hidden = true;
      if (note) note.hidden = false;
    });
  }

  // A failed or lost /cart/add.js response cannot prove nothing was added, so
  // re-read the basket before offering a retry (never a blind repeat Add).
  // Quantity of this variant in the basket (0 when absent). Compared before
  // and after the add, because the variant may already have been in the cart.
  function qtyInCart(variantId) {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
      .then(function (cart) {
        return (cart.items || []).reduce(function (n, i) {
          return String(i.variant_id) === String(variantId) ? n + (i.quantity || 0) : n;
        }, 0);
      });
  }

  // Quantity of this variant in the drawer's rendered lines, or null when the
  // offer is not inside a drawer with lines (Buy Now modal: read /cart.js).
  function renderedQty(block, variantId) {
    var drawer = block.closest('cart-drawer');
    var rows = drawer ? drawer.querySelectorAll('.cart-item[data-cart-line-variant]') : [];
    if (!rows.length) return null;
    var n = 0;
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-cart-line-variant') !== String(variantId)) continue;
      var q = rows[i].querySelector('[name="updates[]"]');
      var v = q ? parseInt(q.getAttribute('value'), 10) : NaN;
      if (isNaN(v)) return null; // ponytail: an unreadable row falls back to the network read
      n += v;
    }
    return n;
  }

  // Screen-reader announcement for the inline status text.
  function announce(btn, text) {
    btn.setAttribute('aria-live', 'polite');
    btn.textContent = text;
  }

  function landed(block, drawer, revision) {
    if (block.getAttribute('data-context') !== 'buynow') {
      // The accepted line stays in the basket; recover its display with GET, never another Add.
      return renderInDrawer(drawer, revision, {});
    }
    var offer = block.querySelector('[data-pc-sb-offer]');
    var note = block.querySelector('[data-pc-sb-note]');
    if (offer) offer.hidden = true;
    if (note) note.hidden = false;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pc-sb-add]');
    if (!btn) return;
    var block = btn.closest('[data-pc-sb]');
    if (!block || btn.disabled) return;
    var drawer = block.closest('cart-drawer');
    document.querySelector('cart-drawer')?.invalidateRender?.();
    var revision = drawer && (drawer.renderRevision || 0);
    var hadFocus = document.activeElement === btn;
    btn.disabled = true;
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    btn.textContent = 'Adding...';
    var id = btn.getAttribute('data-pc-sb-add');
    // Baseline before the add, so a failure can be told apart from an add
    // that landed (the same variant may already be in the cart). In the drawer
    // the rendered lines are the basket the offer was drawn from: no network.
    var rendered = renderedQty(block, id);
    var before = rendered !== null ? Promise.resolve(rendered) : qtyInCart(id).catch(function () { return null; });
    var run = before.then(function () {
      return block.getAttribute('data-context') === 'buynow' ? addInBuyNow(btn, id, block) : addToDrawer(drawer, revision, id);
    });
    run.catch(function () {
      return Promise.all([before, qtyInCart(id)]).then(function (q) {
        var was = q[0], now = q[1];
        if (was !== null && now > was) { landed(block, drawer, revision); return; }
        if (was === null) throw new Error('baseline unknown');
        // Visible inline failure, no alert(): it freezes in-app webviews.
        btn.disabled = false;
        announce(btn, 'Please try again');
        if (hadFocus) btn.focus();
        setTimeout(function () { if (btn.textContent === 'Please try again') btn.textContent = label; }, 2500);
      }, function () {
        // Basket unknown: keep the button disabled so a retry cannot add twice;
        // keep keyboard focus on it instead of dropping to the page body.
        announce(btn, 'Please check your cart');
        if (hadFocus) { btn.setAttribute('tabindex', '0'); btn.focus(); }
      });
    });
  });

  function hydrate(block) {
    if (block.__pcSb) return;
    block.__pcSb = true;
    if (!block.querySelector('[data-pc-sb-list]')) return;
    pick(block).then(function (ps) { render(block, ps); }).catch(function () {});
  }

  // Buy Now: the modal is rendered with the page, but the cart can change
  // afterwards. On open, a cart that already holds a fragrance qualifies.
  window.pcSecondBottleBuyNowOpen = function () {
    var block = document.querySelector('.pc-sb--buynow');
    if (!block) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var offer = block.querySelector('[data-pc-sb-offer]');
      var note = block.querySelector('[data-pc-sb-note]');
      var has = cart && cart.item_count > 0;
      if (offer) offer.hidden = has;
      if (note) note.hidden = !has;
    }).catch(function () {});
  };

  // Buy Now blocks hydrate at page load too, so suggestions are ready when the
  // modal opens; the open hook only switches offer vs note.
  function scan() {
    document.querySelectorAll('[data-pc-sb]').forEach(hydrate);
  }

  recordView();
  scan();
  // The drawer replaces its markup on every cart change (cart-drawer.js
  // renderContents); hydrate each fresh block.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
